export interface TourProgressStore {
  read(): Record<string, boolean>;
  write(progress: Record<string, boolean>): void;
}

export const SANDBOX_PROGRESS_KEY = 'sandbox_tour_progress_v1';

export function createLocalProgressStore(key = SANDBOX_PROGRESS_KEY): TourProgressStore {
  return {
    read() {
      try {
        const raw = window.localStorage.getItem(key);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
      } catch {
        return {};
      }
    },
    write(progress) {
      try {
        window.localStorage.setItem(key, JSON.stringify(progress));
      } catch {
      }
    },
  };
}

export function createMemoryProgressStore(): TourProgressStore {
  let state: Record<string, boolean> = {};
  return {
    read: () => state,
    write: (progress) => {
      state = progress;
    },
  };
}

export function createApiProgressStore(io: {
  get(): Record<string, boolean>;
  put(progress: Record<string, boolean>): void;
}): TourProgressStore {
  return { read: io.get, write: io.put };
}
